import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { editReminderAction } from 'redux/slices/iCalendarV4/reminderSlice';
import { closeNestedDialogAction } from 'redux/slices/nestedDialogSlice';
import ICalendarReminderForm from './ICalendarReminderForm';

const ICalendarReminderEdit = (props) => {
    const { reminder, onSubmit } = props;
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const handleSubmit = ({ reminderDto, onSuccess, onFailure }) => {
        dispatch(
            editReminderAction({
                id: reminder.id,
                dataDto: reminderDto,
                onSuccess: (d) => {
                    onSuccess(d);
                    onSubmit?.(d);
                    dispatch(closeNestedDialogAction());
                },
                onFailure: onFailure,
            }),
        );
    };

    return <ICalendarReminderForm action={t('iCalendar.reminder.edit')} reminder={reminder} onSubmit={handleSubmit} />;
};

export default ICalendarReminderEdit;
